import React, { Component } from 'react';

export class Toggle extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(value, key) {
    this.props.onClick(value, key);
  }

  render() {
    const { value, className, activeClass, activeColor, styles, select, options } = this.props;
    return (
      <div className={className} style={styles}>
        {options.map(option => {
          const isActive = (value === option.value);
          return (
            <button 
              key={option.value} 
              className={isActive ? activeClass : null}
              onClick={() => this.handleClick(option.value, select)}>
              <span style={isActive ? {color: activeColor} : null}>{option.text}</span>
            </button>
          )
        })}
      </div>
    );
  }
}

Toggle.defaultProps = {
  options: [],
  className: 'button-group',
  activeClass: 'active',
  styles: null,
  select: 'type',
}

export default Toggle;
